import { AlertCircle } from "lucide-react";
import styles from "../../styles/ui/Form.module.scss";

/**
 * GDPR consent control. The native checkbox stays in the DOM (visually hidden
 * but focusable) and drives a custom box, so styling never costs semantics.
 */
const ConsentCheckbox = ({ id = "gdprConsent", name, checked, onChange, error, children }) => (
  <div className={styles.consent}>
    <div className={styles.consentBody}>
      <label className={styles.checkboxLabel} htmlFor={id}>
        <input
          type="checkbox"
          id={id}
          name={name || id}
          checked={checked}
          onChange={onChange}
          aria-required="true"
          aria-invalid={error ? "true" : "false"}
          aria-describedby={error ? `${id}-error` : undefined}
        />
        <span className={styles.checkboxBox} aria-hidden="true">
          <svg viewBox="0 0 16 16">
            <path d="M3.5 8.5l3 3 6-6" />
          </svg>
        </span>
        <span className={styles.consentText}>{children}</span>
      </label>
      {error && (
        <p id={`${id}-error`} className={styles.error}>
          <AlertCircle aria-hidden="true" />
          {error}
        </p>
      )}
    </div>
  </div>
);

export default ConsentCheckbox;
